import React from 'react';
import './Team.css';
import ramis from '../assets/ramis.webp';
import alexg from '../assets/AlexG.webp';
import kurt from '../assets/Kurt.webp';
import mattp from '../assets/MattP.webp';
import alex from '../assets/Alex.webp';
import francesco from '../assets/Francesco.webp';
import robbie from '../assets/Robbie.webp';
import rose from '../assets/Rose.webp';
import generic_user_male from '../assets/User_Male.webp';

const Team = () => {
  return (
    <div className="contact-page">
      <div className="team-header">
        <h1>OUR TEAM</h1>
      </div>
      <div className="team-container">

        <div className="team-member">
          <img src={francesco} alt="Francesco Giunta" className="team-image" />
          <div className="team-info">
            <h2>FRANCESCO GIUNTA</h2>
            <p>PERSONAL TRAINER</p>
          </div>
        </div>

        <div className="team-member">
          <img src={kurt} alt="Kurt Aclan" className="team-image" />
          <div className="team-info">
            <h2>KURT ACLAN</h2>
            <p>PERSONAL TRAINER</p>
          </div>
        </div>

        <div className="team-member">
          <img src={alexg} alt="Alex Garossi" className="team-image" />
          <div className="team-info">
            <h2>ALEX GAROSSI</h2>
            <p>PERSONAL TRAINER</p>
          </div>
        </div>

        <div className="team-member">
          <img src={ramis} alt="Ramis Amanoel" className="team-image" />
          <div className="team-info">
            <h2>RAMIS AMANOEL</h2>
            <p>PERSONAL TRAINER</p>
          </div>
        </div>


        <div className="team-member">
          <img src={mattp} alt="Matt Papallo" className="team-image" />
          <div className="team-info">
            <h2>MATT PAPALLO</h2>
            <p>PERSONAL TRAINER</p>
          </div>
        </div>


        <div className="team-member">
          <img src={robbie} alt="Robbie Speranza" className="team-image" />
          <div className="team-info">
            <h2>ROBBIE SPERANZA</h2>
            <p>PHYSIOTHERAPIST</p>
          </div>
        </div>

        <div className="team-member">
          <img src={alex} alt="Alex Pucciarelli" className="team-image" />
          <div className="team-info">
            <h2>ALEX PUCCIARELLI</h2>
            <p>TITLED SPORTS CHIROPRACTOR & AEP</p>
          </div>
        </div>

        <div className="team-member">
          <img src={rose} alt="Rose Pucciarelli" className="team-image" />
          <div className="team-info">
            <h2>ROSE PUCCIARELLI</h2>
            <p>PHYSIOTHERAPIST & AEP</p>
          </div>
        </div>


        <div className="team-member">
          <img src={generic_user_male} alt="Physiotherapist Starting Soon" className="team-image" />
          <div className="team-info">
            <h2>PHYSIOTHERAPIST STARTING SOON</h2>
            <p>PHYSIOTHERAPIST</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Team;
